import { useEffect, useState } from 'react';
import { fetchApiPage } from './reviewsApi.js';

/**
 * The newest reviews, for the fixed-size homepage grid. Reads the first API
 * page only, so it can serve at most API_PAGE_SIZE (20) reviews.
 *
 * @param {string} apiEndpoint
 * @param {Array}  fallbackReviews Used when the request fails (optional).
 */
export const useReviews = (apiEndpoint, fallbackReviews = []) => {
  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);

        const result = await fetchApiPage(apiEndpoint, 1);

        if (cancelled) {
          return;
        }

        setReviews(result.reviews);
        setAverageRating(result.averageRating);
      } catch (err) {
        if (cancelled) {
          return;
        }

        console.error('Error fetching reviews:', err);
        setError(err.message);
        setReviews(fallbackReviews);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [apiEndpoint]);

  return { reviews, averageRating, loading, error };
};

export default useReviews;
